import { createContext, useState, useContext, useMemo } from "react";
import { UserContext } from "./userProvider";
import { ClientContext } from "./clientProvider";
import apiUser from "../apiUser";

export const VoxSoftwaresContext = createContext();

export const VoxSoftwaresProvider = ({ children }) => {
    const { setAlert } = useContext(UserContext);
    const clientContext = useContext(ClientContext);
    const clientes = clientContext?.clientes || [];
    const [vinculos, setVinculos] = useState([]);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const softwares = [
        // { id: 'voxchat', nome: 'Vox Chat', descricao: 'Sistema de chat em tempo real' },
        { id: 'edutech', nome: 'Edutech', descricao: 'Plataforma educacional' }
    ]

    const templateVinculo = {
        voxchat: {
            tipo: 'voxchat',
            nome_organizacao: '',
            email_cliente: '',
            senha: '',
            config: {
                max_usuarios: 10,
                max_grupos: 5,
                storage_mb: 1000
            }
        },
        edutech: {
            tipo: 'edutech',
            nome_organizacao: '',
            email_cliente: '',
            senha: '',
            config: {
                max_alunos: 50,
                max_professores: 5,
                max_turmas: 10
            }
        }
    }

    const getVinculosByCliente = async (clienteId) => {
        try {
            const response = await apiUser.get(`/voxSoftwares/vinculo/${clienteId}`);
            console.log(response.data)
            if (response.data.success) {
                // Garantir que os dados sejam um array válido
                const vinculosData = Array.isArray(response.data.dados) ? response.data.dados : [];
                setVinculos(vinculosData);
                return { sucesso: true, vinculos: vinculosData };
            } else {
                setVinculos([]); // Limpar vínculos em caso de erro
                return { sucesso: false, error: response.data.message };
            }
        } catch (error) {
            console.log(error);
            setVinculos([]); // Limpar vínculos em caso de erro
            return { sucesso: false, error: error.message };
        }
    }

    const createVinculo = async (vinculoData, clienteId) => {
        try {
            const response = await apiUser.post("/voxSoftwares/novoVinculo", {
                vinculo: vinculoData,
                clienteId
            });
            if (!response.data.success) {
                setAlert({ visible: true, title: "Erro", placeholder: response.data.message, confirm: false, type: "negative" });
                return { sucesso: false, error: response.data.message };
            }
            else {
                let newVinculo = response.data.vinculo;
                setVinculos((prevVinculos) => [...prevVinculos, newVinculo]);
                setAlert({ visible: true, title: "Sucesso", placeholder: 'Vínculo criado com sucesso!', confirm: false, type: "success" });
                return { sucesso: true, vinculo: newVinculo };
            }
        } catch (error) {
            console.log(error);
            setAlert({ visible: true, title: "Erro", placeholder: 'Erro ao criar vínculo. Tente novamente.', confirm: false, type: "negative" });
            return { sucesso: false, error: error.message };
        }
    }

    const updateVinculo = async (vinculoData) => {
        try {
            const response = await apiUser.post("/voxSoftwares/updateVinculo", { vinculo: vinculoData });
            if (response.data.success) {
                setAlert({ visible: true, title: "Erro", placeholder: response.data.message, confirm: false, type: "negative" });
                return { sucesso: false, error: response.data.message };
            } else {
                let updatedVinculo = response.data.vinculo;
                setVinculos((prevVinculos) =>
                    prevVinculos.map(v => v.id === updatedVinculo.id ? updatedVinculo : v)
                );
                setAlert({ visible: true, title: "Sucesso", placeholder: 'Vínculo atualizado com sucesso!', confirm: false, type: "success" });
                return { sucesso: true, vinculo: updatedVinculo };
            }
        } catch (error) {
            console.log(error);
            setAlert({ visible: true, title: "Erro", placeholder: 'Erro ao atualizar vínculo.', confirm: false, type: "negative" });
            return { sucesso: false, error: error.message };
        }
    }

    const deleteVinculo = async (vinculoId) => {
        try {
            const response = await apiUser.post("/voxSoftwares/deleteVinculo", { vinculoId });
            if (!response.data.success) {
                setAlert({ visible: true, title: "Erro", placeholder: response.data.message, confirm: false, type: "negative" });
                return { sucesso: false, error: response.data.message };
            } else {
                setVinculos((prevVinculos) => prevVinculos.filter(v => v.id !== vinculoId));
                setAlert({ visible: true, title: "Sucesso", placeholder: response.data.message || 'Vínculo removido com sucesso!', confirm: false, type: "success" });
                return { sucesso: true };
            }
        } catch (error) {
            console.log(error);
            setAlert({ visible: true, title: "Erro", placeholder: 'Erro ao remover vínculo.', confirm: false, type: "negative" });
            return { sucesso: false, error: error.message };
        }
    }


    return (
        <VoxSoftwaresContext.Provider value={{
            clientes,
            selectedCliente,
            setSelectedCliente,
            vinculos,
            setVinculos,
            softwares,
            templateVinculo,
            getVinculosByCliente,
            createVinculo,
            updateVinculo,
            deleteVinculo,
            setAlert
        }}>
            {children}
        </VoxSoftwaresContext.Provider>
    );
};
